import { render } from "./CustomRules.vue?vue&type=template&id=35ccd977"
import script from "./CustomRules.vue?vue&type=script&lang=js"
export * from "./CustomRules.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__